import React, { useState } from 'react';
import { SyncOutlined } from '@ant-design/icons';
import { Row, Col } from 'antd';
import Dropdown from 'components/shared/app/Dropdown';

const filterItems = [
    { value: false, label: 'all campaigns' },
    { value: 0, label: `we're monitoring` },
    { value: 1, label: 'scale up' },
    { value: -1, label: 'optimize' }
];

const RefreshButton = () => {
    const [loading, setLoading] = useState(false);

    return (
        <SyncOutlined
            onClick={() => {
                setLoading(!loading);
            }}
            style={{ color: '#337AED', stroke: '#337AED', fontSize: '25px', strokeWidth: '30' }}
            spin={loading}
        />
    );
};

function Header(props) {
    const metricDropdown = () => (
        <Dropdown
            selectedItem={props.metricItems.find((m) => m.value == props.selectedMetric).label}
            setSelection={props.setSelectedMetric}
            items={props.metricItems}
            setFixedWidth={true}
        />
    );

    const filterDropdown = () => (
        <Dropdown
            selectedItem={filterItems.find((f) => f.value === props.filteredRecCode).label}
            setSelection={props.setFilteredRecCode}
            items={filterItems}
            setFixedWidth={true}
        />
    );

    if (props.mobile) {
        return (
            <>
                <div className="mobile-header">
                    {/* <div className="row align-center justify-end">
                        {metricDropdown()}
                    </div> */}
                    <div className="row align-center justify-end mt">{filterDropdown()}</div>
                </div>
            </>
        );
    } else {
        return (
            <>
                <div className="desktop-header row">
                    <div className="col">
                        <div className="block header blue">
                            <h2>Campaign Performance - Last 7 Days</h2>
                            <Row style={{ marginTop: '20px', textAlign: 'left', width: '100%' }}>
                                <Col span={12} style={{ paddingLeft: '60px' }}>
                                    Campaign
                                </Col>
                                <Col span={3} style={{ textAlign: 'center' }}>
                                    ROAS
                                </Col>
                                <Col span={9} style={{ paddingLeft: '30px' }}>
                                    ROAS Momentum
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="col">
                        <div className="block header green flex column">
                            <h2>Predictive Performance - Next 7 Days</h2>
                            <Row style={{ marginTop: '20px', textAlign: 'left', width: '100%' }}>
                                <Col span={8} style={{ paddingLeft: '30px' }}>
                                    Predicted to:
                                </Col>
                                <Col span={8} style={{ paddingLeft: '30px' }}>
                                    Confidence Score{' '}
                                </Col>
                                <Col span={8} style={{ paddingLeft: '30px' }}>
                                    Recommanded Action
                                </Col>
                            </Row>
                        </div>
                    </div>

                    <div className="page-title">
                        <h4>Predictive ROAS</h4>
                        <div className="filter-dropdown">{filterDropdown()}</div>
                    </div>
                </div>
            </>
        );
    }
}

export default Header;
